export const SignUpFormFields = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  password: 'password',
  passwordConfirmation: 'passwordConfirmation',
};
